/**
 * NF UX-Test (2026-09-25, erweitert 2026-09-26): Warenkorb-Drawer
 *  - Keine Versandschätzung mehr (2026-09-28): die Abfrage von /cart/prepare_shipping_rates.json
 *    mit fester Adresse speicherte PLZ 10115/DE am Warenkorb → Checkout war vorausgefüllt.
 *    Der Drawer zeigt „Versand: wird im Checkout berechnet“; es wird nie eine Adresse gesendet.
 *  - Menge ändern / Entfernen für alle NF-Karten (Zusammenstellungen, Einzelne Fronten, Griffe,
 *    Muster, Maßprüfung) und die Standardliste über den ZEILEN-KEY:
 *      POST /cart/change.js {id: key, quantity, sections: 'side-cart'}
 *    seriell in einer Warteschlange mit Sequenzschutz; danach Neuzeichnen ohne Öffnen.
 *    Nie Zeilennummern (verschieben sich, wenn die Maßprüfung verzögert oben eingefügt wird)
 *    und nie Varianten-IDs (dieselbe Variante kann einzeln UND in einer Zusammenstellung liegen).
 *  - Aufräumen: bleibt keine _bundle_id-Zeile übrig, wird die Maßprüfung (_order_verification)
 *    mit entfernt; alte _bundle_lead-Elternzeilen ohne Positionen ebenso. Zusätzlich nach jedem
 *    Neuzeichnen (auch Öffnen/refresh/Theme): zeigt der Drawer eine Maßprüfung ohne Zusammenstellung
 *    (data-nf-orphan, z. B. verspätet zugelegt, nachdem die letzte Zusammenstellung entfernt wurde),
 *    wird nach ORPHAN_GRACE am frischen Warenkorb erneut geprüft und über die Warteschlange entfernt.
 *  - Schnittstelle für Seiten: window.NFCart = { refresh(): Promise, open(): void, count(): Promise<number> (Positionen) }
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DEBOUNCE = 280;

  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + '€';
  }
  function cartEl() { return document.getElementById('cart'); }
  function hasAjaxCart() { return !!(window.ajaxCart && typeof window.ajaxCart.load === 'function'); }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&'); }

  /* ------------------------------------------------------------------ */
  /* Screenreader-Label des Warenkorb-Links im Header                    */
  /* ------------------------------------------------------------------ */

  // header.liquid rendert aria-label="Warenkorb 292,85€" nur beim Seitenaufruf; danach blieb die
  // Summe stehen. Der Drawer trägt die aktuelle Summe (data-nf-total) → nach jedem Neuzeichnen nachziehen.
  function syncCartLabel(cents) {
    if (cents == null) {
      var src = document.querySelector('#cart [data-nf-total]');
      if (!src) return;
      cents = src.getAttribute('data-nf-total');
    }
    var n = parseInt(cents, 10);
    if (isNaN(n)) return;
    document.querySelectorAll('li.cart > a[aria-label]').forEach(function (a) {
      var cur = a.getAttribute('aria-label') || '';
      var prefix = cur.replace(/\s*[\d.,]+\s*€\s*$/, '').trim() || 'Warenkorb';
      var next = prefix + ' ' + money(n);
      if (cur !== next) a.setAttribute('aria-label', next);
    });
  }

  // Drawer wird per Section Rendering neu befüllt -> auf Änderungen im #cart hören
  var lastRenderAt = 0;
  function watch() {
    var c = cartEl();
    if (!c) return;
    new MutationObserver(function () { lastRenderAt = Date.now(); syncCartLabel(); checkOrphans(); }).observe(c, { childList: true });
    syncCartLabel();
    setTimeout(checkOrphans, 0);   // erst nach dem Laden des ganzen Skripts (Warteschlange initialisiert)
  }
  // Seiten, die den Warenkorb ändern, ohne den Drawer neu zu zeichnen, melden den Stand über dieses Ereignis
  document.addEventListener('nf:cart-updated', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (cart && typeof cart.total_price === 'number') syncCartLabel(cart.total_price); else syncCartLabel();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();

  /* ------------------------------------------------------------------ */
  /* Neuzeichnen (mit Sequenzschutz)                                     */
  /* ------------------------------------------------------------------ */

  var reqSeq = 0;      // jede Anfrage, deren Antwort den Drawer zeichnen darf, bekommt eine Nummer
  var appliedSeq = 0;  // Nummer des zuletzt gezeichneten Stands; ältere Antworten werden verworfen

  function waitForAjaxCart(ms) {
    if (hasAjaxCart()) return Promise.resolve(true);
    var t0 = Date.now();
    return new Promise(function (resolve) {
      (function poll() {
        if (hasAjaxCart()) return resolve(true);
        if (Date.now() - t0 > ms) return resolve(false);
        setTimeout(poll, 100);
      })();
    });
  }

  function focusInfo() {
    var c = cartEl(), a = document.activeElement;
    if (!c || !a || !c.contains(a)) return null;
    var row = a.closest('[data-nf-key]');
    var role = a.matches('[data-nf-step="1"]') ? '[data-nf-step="1"]'
      : a.matches('[data-nf-step="-1"]') ? '[data-nf-step="-1"]'
      : a.matches('input') ? 'input'
      : a.matches('[data-nf-remove]') ? '[data-nf-remove]' : null;
    var all = Array.prototype.slice.call(c.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'));
    return { key: row ? row.getAttribute('data-nf-key') : null, role: role, index: all.indexOf(a) };
  }
  function restoreFocus(info) {
    if (!info) return;
    var c = cartEl();
    if (!c) return;
    var el = null;
    if (info.key && info.role) {
      var row = c.querySelector('[data-nf-key="' + cssEsc(info.key) + '"]');
      if (row) {
        el = row.matches(info.role) ? row : row.querySelector(info.role);
        if (el && el.disabled) el = row.querySelector('input') || null;
      }
    }
    if (!el) {
      var all = c.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
      el = all[Math.max(0, Math.min(info.index, all.length - 1))] || null;
    }
    if (el && typeof el.focus === 'function') { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  // html = Markup der Section „side-cart“ (inkl. <div id="shopify-section-side-cart">)
  function render(html, seq, cart) {
    if (seq < appliedSeq) return false;
    appliedSeq = seq;
    var c = cartEl();
    if (!c || !html) return false;
    var info = focusInfo();
    try {
      if (hasAjaxCart()) {
        window.ajaxCart.load({ sections: { 'side-cart': html } }, false);
      } else {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = doc.getElementById('shopify-section-side-cart');
        if (!sec) return false;
        c.innerHTML = sec.innerHTML;
      }
    } catch (e) {
      console.warn('[NF Cart] Neuzeichnen fehlgeschlagen', e);
      return false;
    }
    restoreFocus(info);
    try { document.dispatchEvent(new CustomEvent('nf:cart-updated', { detail: { cart: cart || null } })); } catch (e) {}
    return true;
  }

  async function fetchAndRender() {
    var seq = ++reqSeq;
    var r = await fetch(ROOT + '?section_id=side-cart', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('side-cart ' + r.status);
    var html = await r.text();
    await waitForAjaxCart(3000);
    render(html, seq, null);
  }

  /* ------------------------------------------------------------------ */
  /* Warteschlange für Mengen / Entfernen (Zeilen-Key)                   */
  /* ------------------------------------------------------------------ */

  var pending = new Map();   // key -> { qty, label }  noch nicht gesendet
  var want = new Map();      // key -> Zielmenge (gesendet oder wartend) bis zum nächsten Neuzeichnen
  var timer = null;
  var busy = false;
  var idleWaiters = [];
  var needRefresh = false;
  var onCartPage = !!document.querySelector('.form-cart, .cart-empty');

  function whenIdle() {
    if (!busy && !pending.size) return Promise.resolve();
    return new Promise(function (r) { idleWaiters.push(r); });
  }
  function settleIdle() {
    if (busy || pending.size) return;
    var w = idleWaiters; idleWaiters = [];
    w.forEach(function (r) { r(); });
  }

  function post(url, body) {
    return fetch(ROOT + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
    });
  }

  function alertMsg(message) {
    try { window.dispatchEvent(new CustomEvent('showAlert', { detail: { message: message, type: 'error' } })); } catch (e) {}
    announce(message);
  }

  // Übrig gebliebene Hilfszeilen: Maßprüfung ohne Zusammenstellung, _bundle_lead ohne Positionen
  function orphanUpdates(cart) {
    var items = (cart && cart.items) || [];
    var ups = {}, n = 0, byBundle = {};
    items.forEach(function (i) {
      var b = i.properties && i.properties._bundle_id;
      if (b) (byBundle[b] = byBundle[b] || []).push(i);
    });
    Object.keys(byBundle).forEach(function (b) {
      var ls = byBundle[b];
      if (ls.every(function (i) { return i.properties._bundle_lead; })) ls.forEach(function (i) { ups[i.key] = 0; n++; });
    });
    var bundleLeft = items.some(function (i) { return i.properties && i.properties._bundle_id && !(i.key in ups); });
    if (!bundleLeft) {
      items.forEach(function (i) { if (i.properties && i.properties._order_verification) { ups[i.key] = 0; n++; } });
    }
    return n ? ups : null;
  }

  // Nach dem Neuzeichnen: verwaiste Maßprüfung? Erst nach einer Wartezeit am FRISCHEN Warenkorb
  // prüfen – die Maßprüfung kann kurz VOR der Zusammenstellung ankommen (Produktseite legt sie
  // zeitversetzt zu), dann ist sie nicht verwaist. Läuft gerade die Warteschlange, räumt drain() selbst auf.
  var ORPHAN_GRACE = 3000;
  var orphanTimer = null;
  var orphanTried = {};
  function checkOrphans() {
    var c = cartEl();
    if (orphanTimer || !c || !c.querySelector('[data-nf-orphan]')) return;
    orphanTimer = setTimeout(function () {
      orphanTimer = null;
      if (busy || pending.size) return;
      getCart().then(function (cart) {
        if (busy || pending.size) return;
        var ups = orphanUpdates(cart);
        if (!ups) return;
        var keys = Object.keys(ups);
        var sig = keys.slice().sort().join(',');
        if (orphanTried[sig] && Date.now() - orphanTried[sig] < 30000) return;   // kein Endlos-Versuch
        orphanTried[sig] = Date.now();
        enqueue(keys.map(function (k) { return [k, 0, '']; }), true, true);
      }).catch(function () {});
    }, ORPHAN_GRACE);
  }

  function setRowBusy(key, on) {
    var c = cartEl();
    if (!c) return;
    c.querySelectorAll('[data-nf-key="' + cssEsc(key) + '"]').forEach(function (el) {
      var row = el.closest('li') || el;
      row.classList.toggle('is-nf-busy', !!on);
      if (on) row.setAttribute('aria-busy', 'true'); else row.removeAttribute('aria-busy');
    });
  }

  // jobs: [[key, qty, label], …]. Jede Zeile einzeln über /cart/change.js; nur ausdrücklich
  // zusammengehörige Keys (grp, z. B. „Zusammenstellung entfernen“) gehen gemeinsam über /cart/update.js.
  var grpSeq = 0;
  function enqueue(jobs, immediate, grouped) {
    var grp = grouped && jobs.length > 1 ? ++grpSeq : 0;
    jobs.forEach(function (j) {
      if (!j[0]) return;
      var q = Math.max(0, j[1] | 0);
      pending.set(j[0], { qty: q, label: j[2] || '', grp: grp });
      want.set(j[0], q);
      setRowBusy(j[0], true);
    });
    clearTimeout(timer);
    if (immediate) drain(); else timer = setTimeout(drain, DEBOUNCE);
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  var drainFailed = false;   // letzte Abarbeitung hatte einen Fehler (Kasse dann nicht automatisch fortsetzen)
  async function drain() {
    clearTimeout(timer);
    timer = null;
    if (busy || !pending.size) { settleIdle(); return; }
    busy = true;
    drainFailed = false;
    var last = null;  // { html, seq, cart } – letzte erfolgreiche Antwort (zum Zeichnen)
    var fresh = null; // Warenkorb der letzten Antwort, wenn danach nichts fehlschlug (sonst unbekannt)
    try {
      for (;;) {
        while (pending.size) {
          var first = pending.entries().next().value;
          var jobs = first[1].grp
            ? Array.from(pending.entries()).filter(function (e) { return e[1].grp === first[1].grp; })
            : [first];
          jobs.forEach(function (e) { pending.delete(e[0]); });
          var seq = ++reqSeq;
          var res;
          if (jobs.length === 1) {
            res = await post('cart/change.js', { id: jobs[0][0], quantity: jobs[0][1].qty, sections: 'side-cart' });
          } else {
            var updates = {};
            jobs.forEach(function (j) { updates[j[0]] = j[1].qty; });
            res = await post('cart/update.js', { updates: updates, sections: 'side-cart' });
          }
          if (!res.ok || res.json.status) {
            var gone = res.status === 400 || res.status === 404;
            alertMsg(gone
              ? 'Diese Position ist nicht mehr im Warenkorb. Der Warenkorb wurde aktualisiert.'
              : (res.json.description || res.json.message || 'Die Menge konnte nicht geändert werden.'));
            needRefresh = true;
            drainFailed = true;
            fresh = null;
            continue;
          }
          last = { html: res.json.sections && res.json.sections['side-cart'], seq: seq, cart: res.json };
          fresh = res.json;
          jobs.forEach(function (j) {
            if (!j[1].label) return;
            var line = (res.json.items || []).find(function (i) { return i.key === j[0]; });
            announce(j[1].qty === 0 ? j[1].label + ': entfernt' : j[1].label + ': Menge ' + (line ? line.quantity : j[1].qty));
          });
        }
        // Warteschlange leer: Hilfszeilen am ENDSTAND prüfen – auch wenn die letzte Änderung fehlschlug
        // (dann Endstand frisch holen), sonst bliebe z. B. die Maßprüfung ohne Zusammenstellung liegen.
        var endCart = fresh;
        if (!endCart) { try { endCart = await getCart(); } catch (eC) { endCart = null; } }
        var extra = endCart && orphanUpdates(endCart);
        if (extra) {
          var seq2 = ++reqSeq;
          var res2 = await post('cart/update.js', { updates: extra, sections: 'side-cart' });
          if (res2.ok && !res2.json.status) { last = { html: res2.json.sections && res2.json.sections['side-cart'], seq: seq2, cart: res2.json }; fresh = res2.json; }
          else needRefresh = true;
        }
        if (!pending.size) break;   // während des Aufräumens neu Gewünschtes → noch eine Runde
      }
      if (needRefresh || !last || !last.html) {
        needRefresh = false;
        await fetchAndRender();
      } else if (!pending.size) {
        render(last.html, last.seq, last.cart);
      }
      if (!pending.size) want.clear();
      if (onCartPage) { location.reload(); return; }
    } catch (e) {
      console.warn('[NF Cart] Änderung fehlgeschlagen', e);
      drainFailed = true;
      alertMsg('Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es noch einmal.');
      want.clear();
      try { await fetchAndRender(); } catch (e2) {}
    } finally {
      busy = false;
      if (pending.size) drain(); else settleIdle();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Screenreader-Hinweise                                               */
  /* ------------------------------------------------------------------ */

  var live = null;
  function announce(text) {
    if (!text) return;
    if (!live) {
      live = document.createElement('div');
      live.className = 'nf-vh';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      (document.body || document.documentElement).appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 30);
  }

  /* ------------------------------------------------------------------ */
  /* Bedienung                                                           */
  /* ------------------------------------------------------------------ */

  function rowOf(el) { return el && el.closest ? el.closest('[data-nf-key]') : null; }
  function currentQty(row) {
    var key = row.getAttribute('data-nf-key');
    if (want.has(key)) return want.get(key);
    return parseInt(row.getAttribute('data-nf-qty'), 10) || 0;
  }
  function limits(row) {
    var min = parseInt(row.getAttribute('data-nf-min') || row.getAttribute('min'), 10);
    var max = parseInt(row.getAttribute('data-nf-max') || row.getAttribute('max'), 10);
    var inc = parseInt(row.getAttribute('data-nf-inc') || row.getAttribute('step'), 10);
    return { min: min > 0 ? min : 1, max: max > 0 ? max : Infinity, inc: inc > 0 ? inc : 1 };
  }
  function paintRow(row, qty) {
    var lim = limits(row);
    var input = row.querySelector('[data-nf-qty-input]');
    if (input) input.value = qty;
    var dec = row.querySelector('[data-nf-step="-1"]');
    var inc = row.querySelector('[data-nf-step="1"]');
    // Fokus nicht auf einem gleich deaktivierten Knopf stehen lassen
    if (dec) { var dd = qty <= lim.min; if (dd && document.activeElement === dec && input) input.focus(); dec.disabled = dd; }
    if (inc) { var di = qty >= lim.max; if (di && document.activeElement === inc && input) input.focus(); inc.disabled = di; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var c = cartEl();
    if (!c || !c.contains(t)) return;

    var step = t.closest('[data-nf-step]');
    if (step) {
      e.preventDefault();
      if (step.disabled) return;
      var row = rowOf(step);
      if (!row) return;
      var lim = limits(row);
      var q = currentQty(row) + (parseInt(step.getAttribute('data-nf-step'), 10) < 0 ? -lim.inc : lim.inc);
      q = Math.max(lim.min, Math.min(lim.max, q));
      paintRow(row, q);
      enqueue([[row.getAttribute('data-nf-key'), q, row.getAttribute('data-nf-label')]]);
      return;
    }

    var rm = t.closest('[data-nf-remove]');
    if (rm) {
      e.preventDefault();
      var r = rm.hasAttribute('data-nf-key') ? rm : rowOf(rm);
      if (!r) return;
      var label = r.getAttribute('data-nf-label') || '';
      var keys = String(r.getAttribute('data-nf-keys') || '').split(',').filter(Boolean);
      if (!keys.length) keys = [r.getAttribute('data-nf-key')];
      var li = rm.closest('li');
      if (li) li.classList.add('is-nf-removing');
      enqueue(keys.map(function (k, i) { return [k, 0, i === 0 ? label : '']; }), true, true);
      return;
    }

    var grp = t.closest('[data-nf-remove-group]');
    if (grp) {
      e.preventDefault();
      var gkeys = String(grp.getAttribute('data-nf-keys') || '').split(',').filter(Boolean);
      if (!gkeys.length) return;
      grp.disabled = true;
      grp.textContent = 'Wird entfernt …';
      var sec = grp.closest('section');
      if (sec) sec.classList.add('is-nf-removing');
      enqueue(gkeys.map(function (k, i) { return [k, 0, i === 0 ? 'Zusammenstellung' : '']; }), true, true);
    }
  });

  // Space auf <a role="button"> (Standardliste) wie Klick behandeln
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var c = cartEl();
    if (!c || !c.contains(t)) return;
    if ((e.key === ' ' || e.key === 'Spacebar') && t.matches('a[data-nf-remove]')) { e.preventDefault(); t.click(); return; }
    if (e.key === 'Enter' && t.matches('[data-nf-qty-input], input[data-nf-std]')) { e.preventDefault(); commitInput(t); }
  });

  function commitInput(input) {
    var row = input.hasAttribute('data-nf-key') ? input : rowOf(input);
    if (!row) return;
    var key = row.getAttribute('data-nf-key');
    var lim = limits(row);
    var cur = currentQty(row);
    var raw = String(input.value).replace(/[^\d]/g, '');
    var q = raw === '' ? NaN : parseInt(raw, 10);
    if (isNaN(q)) { input.value = cur; return; }
    if (q !== 0) q = Math.max(lim.min, Math.min(lim.max, q));
    if (q === cur) { input.value = cur; return; }
    if (input.hasAttribute('data-nf-qty-input')) paintRow(row, q); else input.value = q;
    enqueue([[key, q, row.getAttribute('data-nf-label')]], q === 0);
  }

  // change-Ereignisse: eigene Eingabefelder und die Theme-Stepper der Standardliste.
  // Das Theme feuert „change“ ohne bubbles -> in der Capture-Phase abhören.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var c = cartEl();
    if (!c || !c.contains(t)) return;
    if (t.matches('[data-nf-qty-input], input[data-nf-std]')) commitInput(t);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Zur Kasse erst, wenn alle Mengenänderungen angekommen sind           */
  /* ------------------------------------------------------------------ */

  // Das Formular (data-hold="0") schickt sofort ab; eine eben geklickte Menge wartet aber noch
  // 280 ms bzw. ist unterwegs → Checkout sähe den alten Stand. Deshalb: anhalten, sofort senden,
  // auf Leerlauf warten, dann das (neu gezeichnete) Formular erneut abschicken.
  var checkoutHold = false;
  function checkoutForm() {
    var c = cartEl();
    if (!c) return null;
    var forms = c.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) if (forms[i].querySelector('[name="checkout"]')) return forms[i];
    return null;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var c = cartEl();
    if (!f || !c || !c.contains(f) || !f.querySelector('[name="checkout"]')) return;
    if (!checkoutHold && !busy && !pending.size) return;   // nichts offen → normal weiter
    e.preventDefault();
    e.stopImmediatePropagation();
    if (checkoutHold) return;                               // Doppelklick während des Wartens
    checkoutHold = true;
    var btn = e.submitter || f.querySelector('button[name="checkout"], [type="submit"][name="checkout"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-nf-busy'); }
    announce('Einen Moment, der Warenkorb wird aktualisiert …');
    if (pending.size && !busy) drain();                     // Entprellung überspringen
    whenIdle().then(function () {
      checkoutHold = false;
      var f2 = checkoutForm();
      if (drainFailed || !f2) {
        // Fehler wurde gemeldet und der Warenkorb neu gezeichnet → Kunde entscheidet neu
        var b2 = f2 && f2.querySelector('button[name="checkout"]');
        if (b2) { b2.removeAttribute('aria-busy'); b2.classList.remove('is-nf-busy'); }
        return;
      }
      var sub = f2.querySelector('button[name="checkout"]');
      if (typeof f2.requestSubmit === 'function') f2.requestSubmit(sub || undefined);
      else f2.submit();
    });
  }, true);

  /* ------------------------------------------------------------------ */
  /* Öffnen / Aktualität                                                 */
  /* ------------------------------------------------------------------ */

  // Läuft schon ein Neuzeichnen, kann dessen Abruf VOR der neuen Änderung (z. B. /cart/add der Seite)
  // liegen → vormerken und danach noch einmal holen; das zurückgegebene Promise endet erst nach dem
  // letzten Durchlauf.
  var refreshing = null;
  var refreshAgain = false;
  function refresh() {
    if (refreshing) { refreshAgain = true; return refreshing; }
    refreshing = (async function () {
      do {
        refreshAgain = false;
        await whenIdle();
        try { await fetchAndRender(); } catch (e) {
          console.warn('[NF Cart] refresh', e);
          if (!refreshAgain && hasAjaxCart()) window.ajaxCart.load(false, false, false, true);
        }
      } while (refreshAgain);
    })().then(function () { refreshing = null; });
    return refreshing;
  }

  // Der Header-Link öffnet den Drawer ohne neu zu laden -> beim Öffnen einmal nachladen,
  // wenn der gezeigte Stand älter als 1,5 s ist (nicht direkt nach einem Neuzeichnen).
  window.addEventListener('themeCartOpened', function () {
    // läuft gerade ein Neuzeichnen, dessen Stand älter sein kann: danach noch einmal holen
    if (refreshing) { refreshAgain = true; return; }
    if (Date.now() - lastRenderAt > 1500 && !busy && !pending.size) refresh();
  });

  window.NFCart = {
    refresh: refresh,
    open: function () {
      if (!hasAjaxCart()) { location.href = ROOT + 'cart'; return; }
      var c = cartEl();
      if (!c || c.childNodes.length < 3) window.ajaxCart.load(false, true, false, true);
      else window.ajaxCart.load();
    },
    // Anzahl Positionen – gleiche Bedeutung wie der Header-Zähler (assets/custom.js) und data-totalqty
    count: function () {
      return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return (cart.items || []).length; });
    }
  };
})();
